import React, { useEffect, useState, useContext } from 'react';
import { getDiagnosticModels, postDiagnosticModels, getDiagnosticModelsDropdown } from '../../../Core/Service/diagnosticFaults-service';
import { Grid, FormLabel, CircularProgress } from '@material-ui/core';
import { SecondaryButton, TextBox, Multiselect } from '../../../Core/FormInput';
import AppContext from './../../../App/AppContext';

const DiagnosticModelsModal = (props) => {
    const { showToast } = useContext(AppContext);
    
    const [state, setState] = useState({
        id: props.id || null,
        name: '',
        faults: [], // Array of fault objects for Multiselect
        options: [], // Dropdown options
        errors: {},
        loading: true,
        saving: false
    });

    useEffect(() => {
        const loadInitData = async () => {
            setState(st => ({ ...st, loading: true }));
            try {
                // Fetch options first
                let optionsRes = await getDiagnosticModelsDropdown();
                let optionsData = optionsRes?.success ? (optionsRes.data?.list || optionsRes.data?.table || optionsRes.data || []) : [];

                let name = '';
                let id = null;
                let faultsData = [];

                // Fetch specific model data if editing
                if (props.id) {
                    let res = await getDiagnosticModels(props.id); // Call GET API with parameter 1 (props.id)
                    if (res && res.success) {
                        let data = res.data?.models?.[0] || {};
                        name = data.diagnosticModelName || '';
                        id = data.diagnosticModelID;
                        
                        // The API returns faultIds alongside models in res.data
                        let rawFaultIds = res.data?.faultIds || data.faultIds || [];
                        if (rawFaultIds.length > 0) {
                            let extractedIds = rawFaultIds.map(f => typeof f === 'object' ? f.id : f);
                            faultsData = optionsData.filter(opt => extractedIds.includes(opt.id) || extractedIds.includes(opt.diagnosticModelID));
                        }
                    }
                }

                setState((st) => ({
                    ...st,
                    name: name,
                    id: id,
                    faults: faultsData,
                    options: optionsData,
                    loading: false
                }));
            } catch (error) {
                console.error("Error loading modal data", error);
                setState(st => ({ ...st, loading: false }));
            }
        };

        loadInitData();
    }, [props.id]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleFaultsChange = (event, newValue) => {
        setState((st) => ({
            ...st,
            faults: newValue
        }));
    };

    const handleSubmit = async () => {
        if (!state.name) {
            setState(st => ({ ...st, errors: { name: 'Name is required' } }));
            return;
        }

        setState(st => ({ ...st, saving: true }));

        const faultIds = state.faults.map(f => f.id || f.diagnosticModelID);

        let data = {
            id: state.id,
            name: state.name,
            faultIds: faultIds
        };

        let res = await postDiagnosticModels(data);
        if (res && res.success) {
            showToast(`Diagnostic Model Saved Successfully`);
            props.onClose(true); // Close modal and trigger reload
        } else {
            console.error(res?.message);
            showToast(res?.message || 'Error saving model');
            setState(st => ({ ...st, saving: false }));
        }
    };

    if (state.loading) {
        return (
            <Grid container justifyContent="center" style={{ padding: 40 }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormLabel component="legend" className="mandatoryfields" style={{ marginBottom: 5 }}>
                        Model Name
                    </FormLabel>
                    <TextBox 
                        name="name" 
                        onChange={handleInput} 
                        value={state.name} 
                        autoFocus={true} 
                    />
                    <span className="mandatoryfields">{state.errors?.name}</span>
                </Grid>

                <Grid item xs={12} style={{ marginTop: 10 }}>
                    <FormLabel component="legend" style={{ marginBottom: 5 }}>
                        Associated Faults
                    </FormLabel>
                    <Multiselect
                        options={state.options}
                        value={state.faults}
                        onChange={handleFaultsChange}
                        placeholder="Select Faults..."
                    />
                </Grid>

                <Grid item xs={12} style={{ marginTop: 20, marginBottom: 10 }}>
                    <SecondaryButton fullWidth onClick={handleSubmit} disabled={state.saving}>
                        {state.saving ? 'Saving...' : 'Save'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default DiagnosticModelsModal;
